

// product price discount upd


(function () {
  function formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    cents = Number(cents || 0);

    var format = (window.theme && window.theme.moneyFormat) || "${{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number == null) return "0";

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    var value = "";
    var match = format.match(placeholderRegex);

    if (!match) return cents;

    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function getDiscountText(format, amount, percent, saleText) {
    switch (format) {
      case "sale_text":
        return saleText || "Sale";
      case "amount_off":
        return formatMoney(amount);
      case "minus_amount":
        return "-" + formatMoney(amount);
      case "save_amount":
        return "-" + formatMoney(amount);
      case "percent_off":
        return percent + "%";
      case "minus_percent":
        return "-" + percent + "%";
      case "save_percent":
        return "-" + percent + "%";
      default:
        return "-" + percent + "%";
    }
  }

  function updatePriceScope(scope, variant) {
    var configEl = scope.querySelector("[data-collection-discount-config]");
    var priceEl = scope.querySelector("[data-price]");
    var compareEl = scope.querySelector("[data-compare-price]");
    var discountEl = scope.querySelector("[data-price-discount]");

    if (!priceEl || !compareEl || !configEl) return;

    var unavailableText =
      window.theme &&
      window.theme.strings &&
      window.theme.strings.products &&
      window.theme.strings.products.product &&
      window.theme.strings.products.product.unavailable
        ? window.theme.strings.products.product.unavailable
        : "Unavailable";

    if (!variant) {
      priceEl.innerHTML = unavailableText;
      compareEl.innerHTML = "";
      if (discountEl) {
        discountEl.textContent = "";
        discountEl.style.display = "none";
      }
      return;
    }

    var enabled = configEl.dataset.enabled === "true";
    var percent = parseFloat(configEl.dataset.percent || "0");
    var useCompareAt = configEl.dataset.useCompareAt === "true";
    var discountFormat = configEl.dataset.discountFormat || "minus_percent";
    var saleText = configEl.dataset.saleText || "Sale";

    var variantPrice = Number(variant.price || 0);
    var variantCompareAt = Number(variant.compare_at_price || 0);
    var hasNativeSale = variantCompareAt > variantPrice && variantCompareAt > 0;

    if (
      enabled &&
      percent > 0 &&
      percent < 100 &&
      variantPrice > 0 &&
      !(useCompareAt && hasNativeSale)
    ) {
      var discountAmount = Math.round((variantPrice * percent) / 100);
      var discountedPrice = variantPrice - discountAmount;

      priceEl.innerHTML = formatMoney(discountedPrice);
      compareEl.innerHTML = formatMoney(variantPrice);

      if (discountEl) {
        discountEl.textContent = getDiscountText(discountFormat, discountAmount, percent, saleText);
        discountEl.style.display = "";
      }

      return;
    }

    priceEl.innerHTML = formatMoney(variantPrice);
    compareEl.innerHTML = hasNativeSale ? formatMoney(variantCompareAt) : "";

    if (discountEl) {
      if (hasNativeSale) {
        var nativeDiscountAmount = variantCompareAt - variantPrice;
        var nativeDiscountPercent = Math.round((nativeDiscountAmount * 100) / variantCompareAt);
        discountEl.textContent = getDiscountText(
          discountFormat,
          nativeDiscountAmount,
          nativeDiscountPercent,
          saleText
        );
        discountEl.style.display = "";
      } else {
        discountEl.textContent = "";
        discountEl.style.display = "none";
      }
    }
  }

  function updateAllProductPrices(variant) {
    var scopes = document.querySelectorAll(
      ".product__block--product-header, .product__price-block"
    );

    scopes.forEach(function (scope) {
      if (scope.querySelector("[data-collection-discount-config]")) {
        updatePriceScope(scope, variant);
      }
    });
  }

  document.addEventListener("product:variant-change", function (event) {
    var variant = event.detail && event.detail.variant ? event.detail.variant : null;
    updateAllProductPrices(variant);
  });
})();